export default "__VITE_ASSET__BMIOQiyF__"